var App = App || {};

App.Header = (function ($) {
    "use strict";

    const selectors = {
        searchOffcanvas: "#header-offcanvas-search",
        searchInput: "#SiteSearch_Header"
    };

    function init() {
        bindSiteSearchFocus();
    }

    function bindSiteSearchFocus() {
        $(selectors.searchOffcanvas)
            .off("shown.bs.offcanvas.appHeaderSearchFocus")
            .on("shown.bs.offcanvas.appHeaderSearchFocus", function () {
                const searchInput = $(this).find(selectors.searchInput).first();

                if (searchInput.length) {
                    searchInput.trigger("focus");
                }
            });
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.Header.init();
});